import * as Sentry from "@sentry/react";
import {
  ENVIRONMENT,
  resolveSentryEnvironment,
  resolveSentryTunnel,
} from "./constants/env";

const SENTRY_DSN =
  "https://87ad26fd6738d43663c2b91deff6ead3@o4504592270491648.ingest.us.sentry.io/4511568862052352";

export const initSentry = (appEnvironment = ENVIRONMENT) => {
  const tunnel = resolveSentryTunnel(appEnvironment);

  Sentry.init({
    dsn: SENTRY_DSN,
    enabled: true,
    environment: resolveSentryEnvironment(appEnvironment),
    ...(tunnel ? { tunnel } : {}),
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1,
    sendDefaultPii: true,
    enableLogs: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
  });
};
